import { render, staticRenderFns } from "./PopupPushConfig.vue?vue&type=template&id=d1e6561c&scoped=true"
import script from "./PopupPushConfig.vue?vue&type=script&lang=js"
export * from "./PopupPushConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e6561c",
  null
  
)

export default component.exports